/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Scope_StorefrontInputs */

const vi_api_keys_scope_storefront = /** @type {(inputs: Api_Keys_Scope_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web bán hàng (storefront)`)
};

/**

* @param {Api_Keys_Scope_StorefrontInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_scope_storefront = /** @type {((inputs?: Api_Keys_Scope_StorefrontInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Scope_StorefrontInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_scope_storefront(inputs)
});